import { render, staticRenderFns } from "./RiskAndDisclosure.vue?vue&type=template&id=49722902&scoped=true&"
import script from "./RiskAndDisclosure.vue?vue&type=script&lang=js&"
export * from "./RiskAndDisclosure.vue?vue&type=script&lang=js&"
import style0 from "./RiskAndDisclosure.vue?vue&type=style&index=0&id=49722902&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49722902",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VDivider,VFlex,VLayout,VList,VListItem,VListItemContent,VListItemGroup})
